import { render } from "./AddAdminModal.vue?vue&type=template&id=1a027dfe&scoped=true"
import script from "./AddAdminModal.vue?vue&type=script&lang=js"
export * from "./AddAdminModal.vue?vue&type=script&lang=js"

import "./AddAdminModal.vue?vue&type=style&index=0&id=1a027dfe&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/admin.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a027dfe"]])

export default __exports__